import React, { useState } from 'react';

import { Box } from '@mui/material';

import { CommonComponentProps, ImageObject } from '../../pages/types';
import ImageFullscreen from './image-fullscreen';

interface SingleImageProps extends CommonComponentProps {
  image?: ImageObject;
  imageWidth?: string;
  imageHeight?: string;
  showCaption?: boolean;
}

const SingleImage: React.FC<SingleImageProps> = ({
  id,
  image,
  imageWidth = '100%',
  imageHeight = 'auto',
  showCaption = false,
  sx,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!image || !image.url) {
    return null;
  }

  // Ensure URL is properly encoded
  const imageUrl = image.url.replace(/ /g, '%20');

  // Create an array with just this single image for the fullscreen viewer
  const images = [image];

  return (
    <Box
      id={id}
      sx={{
        maxWidth: '1100px',
        width: '100%',
        textAlign: 'center',
        margin: '0 auto',
        ...sx,
      }}
    >
      <ImageFullscreen
        firstImage={image}
        images={images}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
      >
        <Box
          component="img"
          src={imageUrl}
          alt={image.altText || 'Image'}
          sx={{
            width: imageWidth ? imageWidth : '100%',
            height: imageHeight ? imageHeight : 'auto',
          }}
        />
      </ImageFullscreen>
    </Box>
  );
};

export default SingleImage;
